import styled from 'styled-components'

const ProductDocuments = styled.ul`
  &&& {
    clear: both;
    display: block;
    margin-top: 30px;
    padding: 0;
  }

  > li {
    list-style-type: none;

    a {
      color: ${props => props.theme.color.alias.link.default.color};
      cursor: pointer;
      font-weight: ${props => props.theme.font.weight.bold};
      position: relative;
      padding: 4px 0 4px 25px;
      text-decoration: underline;

      &:hover,
      &:active {
        color: ${props => props.theme.color.alias.link.hover.text.color};
      }

      &::before {
        content: '';
        position: absolute;
        top: 3px;
        left: 0;
        width: 18px;
        height: 18px;
        background-image: url(//documents.4rgos.it/v1/static/pdf-icon);
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100%;
      }
    }

    & + li {
      margin-top: 12px;
    }
  }
`

export { ProductDocuments } // eslint-disable-line
